/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser | undefined }) {
  const { currentUser } = initialState || {};

  return {
    isAccessible: (route: any) =>
      currentUser?.access &&
      currentUser?.access.find((role: string): boolean => route.authority.includes(role)),
    banPlayer: currentUser?.permissions?.canBanPlayer,
    adjustBalance: currentUser?.permissions?.canAdjustBalance,
    grantBonus: currentUser?.permissions?.canGrantBonus,
    approveWithdrawals: currentUser?.permissions?.canApproveWithdrawals,
    enableMatches: currentUser?.permissions?.canEnableMatches,
    activateMatches: currentUser?.permissions?.canActivateMatches,
    enableKyc: currentUser?.permissions?.canKycActions,
    createTables: currentUser?.permissions?.canCreateTables,
    flagPlayers: currentUser?.permissions?.canFlagPlayers,
    haptikSwitch: currentUser?.permissions?.canHaptikSwitch,
    showfreebetCoupon: currentUser?.permissions?.canFreebetCoupon,
    depositCheck: currentUser?.permissions?.canDepositCheck,
    withdrawalsCheck: currentUser?.permissions?.canWithdrawalsCheck,
    showPlayerAccount: currentUser?.permissions?.canShowPlayerAccount,
    showPhnAndEmail: currentUser?.permissions?.canViewPhoneAndEmail,
    showPromoType: currentUser?.permissions?.canShowPromoType,
    batchUpdateCms: currentUser?.permissions?.canBatchUpdateCms,
    approveBankAccount: currentUser?.permissions?.canApproveBankAccount,
    showEditInCms: currentUser?.permissions?.canShowEditInCms,
    showBots: currentUser?.permissions?.canShowBots,
    createBackendDeposit: currentUser?.permissions?.canCreateBackendDeposit,
    approveBackendDeposit: currentUser?.permissions?.canApproveBackendDeposit,
    permaBanPlayer: currentUser?.permissions?.canPermaBanPlayer,
    createBackendWithdrawals: currentUser?.permissions?.canCreateBackendWithdrawals,
    approveBackendWithdrawals: currentUser?.permissions?.canApproveBackendWithdrawals,
    approveManualDeposit: currentUser?.permissions?.canApproveManualDeposit,
    accessEventTicker: currentUser?.permissions?.canAccessEventTicker,
    convertLockedBonus: currentUser?.permissions?.canConvertLockedToEarnedBonus,
    verifyKyc: currentUser?.permissions?.canVerifyBackendKyc,
    adminActivity: currentUser?.permissions?.canAdminActivity,
    updatePhoneNumber: currentUser?.permissions?.canUpdatePhoneNumber,
    ApproveRejectedKyc: currentUser?.permissions?.canApproveRejectedKyc,
    canViewPlayerStats: currentUser?.permissions?.canViewPlayerStats,
    canViewTds: currentUser?.permissions?.canViewTds,
    canUploadTds: currentUser?.permissions?.canUploadTds,
    clawbackLockedBonus: currentUser?.permissions?.canClawbackLockedBonus,
    adjustLockedBonus: currentUser?.permissions?.canAdjustLockedBonus,
    convertLockedToPlayBonus: currentUser?.permissions?.canConvertLockedToPlayBonus,
    editWithdrawalFee: currentUser?.permissions?.canEditWithdrawalFee,
    canCreateDynamicSegment: currentUser?.permissions?.canCreateDynamicSegment,
    canResetWithdrawal: currentUser?.permissions?.canResetWithdrawal,
    canResetDeposit: currentUser?.permissions?.canResetDeposit,
    settleCreditNote: currentUser?.permissions?.canSettleCreditNote,
    createClawback: currentUser?.permissions?.canCreateClawback,
    canEditLoyalty: currentUser?.permissions?.canEditLoyalty,
    canWhatsappUrlUpdateButton: currentUser?.permissions?.canWhatsappUrlUpdateButton,
    canSeeLoyaltyHistory: currentUser?.permissions?.canSeeLoyaltyHistory,
    approveCashDeposit: currentUser?.permissions?.canApproveCashDeposit,
    canResetPlayerPassword: currentUser?.permissions?.canResetPlayerPassword,
    canAnalytics: currentUser?.permissions?.canAnalytics,
    canViewManualUtrSlip: currentUser?.permissions?.canViewManualUtrSlip,
    canDeleteBankAccount: currentUser?.permissions?.canDeleteBankAccount,
    canUpdateCouponStatus: currentUser?.permissions?.canUpdateCouponStatus,
    canViewWdPriority: currentUser?.permissions?.canViewWdPriority,
    canToggleWdPriority: currentUser?.permissions?.canToggleWdPriority,
    canSetTotalCouponRedeems: currentUser?.permissions?.canSetTotalCouponRedeems,
    canCreatePlayers: currentUser?.permissions?.canCreatePlayers,
    canSeeIPAddressListing: currentUser?.permissions?.canSeeIpAddressListing,
    createPlayerFlag: currentUser?.permissions?.canBulkAssignPlayerFlag,
    editCryptoRate: currentUser?.permissions?.canEditCryptoRate,
    canNewPhoneNumberAdd: currentUser?.permissions?.canNewPhoneNumberAdd,
    viewWagerHistory: currentUser?.permissions?.canViewWagerHistory,
    canSeeGameProviderUsername: currentUser?.permissions?.canSeeGameProviderUsername,
    gameSegment: currentUser?.permissions?.canSeeGameSegment,
    cloneCoupon: currentUser?.permissions?.canSeeCloneCoupon,
    canEnableAutomatedWithdrawal: currentUser?.permissions?.canEnableAutomatedWithdrawal,
    canEnableAutomatedWithdrawalDryRun: currentUser?.permissions?.canEnableAutomatedWithdrawalDryRun,
    canUpdateAutomatedWithdrawalRules: currentUser?.permissions?.canUpdateAutomatedWithdrawalRules,
    canEditLeaderboard: currentUser?.permissions?.canEditLeaderboard,
    canSeeMetaTitle: currentUser?.permissions?.canSeeMetaTitle,
    canSeeCloneBanner: currentUser?.permissions?.canSeeCloneBanner,
    canSeeBonusUsedAndCashback: currentUser?.permissions?.canSeeBonusUsedAndCashback,
    canManageAdminUsers: currentUser?.permissions?.canManageAdminUsers,
    canManageAdminRoles: currentUser?.permissions?.canManageAdminRoles,
    canManageBanner: currentUser?.permissions?.canManageBanner,
    canManageCoupon: currentUser?.permissions?.canManageCoupon,
    canManageManualAccount: currentUser?.permissions?.canManageManualAccount,
    canManageRedeemcode: currentUser?.permissions?.canManageRedeemcode,
    canManageScratchcard: currentUser?.permissions?.canManageScratchcard,
    canManageGames: currentUser?.permissions?.canManageGames,
    canManagePsps: currentUser?.permissions?.canManagePsps,
    canManageSegments: currentUser?.permissions?.canManageSegments,
    canCreateCashback: currentUser?.permissions?.canCreateCashback,
    canImportLlManager: currentUser?.permissions?.canImportLlManager,
    canToggleInstantWdFee: currentUser?.permissions?.canToggleInstantWdFee,
    canSeeUtilityTab: currentUser?.permissions?.canSeeUtilityTab,
    canSeeEligiblePgs: currentUser?.permissions?.canSeeEligiblePgs,
    canSeeEligibleCoupons: currentUser?.permissions?.canSeeEligibleCoupons,
    canSeeWithdrawalCriteria: currentUser?.permissions?.canSeeWithdrawalCriteria,
    canViewPasswordUpdateDetails: currentUser?.permissions?.canViewPasswordUpdateDetails,
    canAccessWagerRules: currentUser?.permissions?.canAccessWagerRules,
    canViewPlayBonus: currentUser?.permissions?.canViewPlayBonus,
    canShowAssignUnassignTag: currentUser?.permissions?.canShowAssignUnassignTag,
    canArchiveWdAccount: currentUser?.permissions?.canArchiveWdAccount,
    canListGms: currentUser?.permissions?.canListGms,
    canListGmsCashback: currentUser?.permissions?.canListGmsCashback,
    canManageGms: currentUser?.permissions?.canManageGms,
    canAssignSmsProvider: currentUser?.permissions?.canAssignSmsProvider,
    canListCscStates: currentUser?.permissions?.canListCscStates,
    canListPaymentMethodTypes: currentUser?.permissions?.canListPaymentMethodTypes,
  };
}
